<template>
  <v-btn
    color="pipefishGreen"
    small
    to="/admin"
  >
  <v-icon class="backIcon" left dark>mdi-arrow-left</v-icon>
  Back
</v-btn>
</template>

<script>
export default {

}
</script>

<style>

</style>
